module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAASCAYAAABit09LAAAAAXNSR0IArs4c6QAAARBJREFUKBVjmDVr1kog9mQgAJiA8tP+//+/ePbs2f741DKCJIEmWgEVbwIyM9PT01dj0wBWCFVsCqS3AnFhWlraUnTFIKvBACh5GshwA5rcB3RGIlQYTsFNhInMmTNH5+/fv7uB/AagM2bCxOEmwgRSUlKuANmOQFw7c+bMPJg4hokwCaDJKkCT9zIxMU1JTU3txqkQpGH+/PkKv3//3gdkzsOwGmYiOo3TRHSrmdF1gvhAT2gAgwlkZQ8w2PpBYhhWg4IHKL4fiJuBwTMJpAgEUKwGRqUB0KSdQJ9WAH06H6IEQsIVAhXhjUKwQqISBVCRPdC6tUDrkoHWbUS2DpnNAuRkMTIyxgIVbUeWQGcDAGNYb/X1xXpVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/next.png
// module id = Lw/G
// module chunks = 0